import {
  EditInDialogButtonProps,
  EditInDialogButton as EditInDialogButtonRa,
} from '@react-admin/ra-form-layout';
import { ResourceContextProvider } from 'react-admin';

import { useCanAccess } from '@sh4res/bo-common/hooks';
import { disableBackdropClose, Resources } from '@sh4res/bo-common/utils';

// Omit resource from EditInDialogButtonProps to make it non optional
type Props = Omit<EditInDialogButtonProps, 'resource'> & {
  resource: Resources;
  testId?: string;
};

export const EditInDialogButton = ({ resource, testId, ...props }: Props) => {
  const canAccess = useCanAccess({
    resource,
    action: 'edit',
  });

  return canAccess ? (
    <ResourceContextProvider value={resource}>
      <EditInDialogButtonRa
        {...props}
        onClose={disableBackdropClose}
        ButtonProps={{
          ...props.ButtonProps,
          ...(testId !== undefined && { 'data-testid': testId }),
        }}
      />
    </ResourceContextProvider>
  ) : null;
};
